import {getCustomerProfile} from '@/api/customerApi'
import {getPublicActualPrices, getPublicProductBySku} from '@/api/programCheckoutApi'
import {setAuthorizationToken} from '@/axios'
import {useAuthStore} from '@/stores/authStore'
import {useCartProducts} from '@/stores/use-cart-products'
import {ETapCheckout} from '@/types'

const firstText = (...values) => {
    for (const value of values) {
        if (value != null) {
            const text = String(value).trim()

            if (text) {
                return text
            }
        }
    }

    return ''
}

const storedUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user') || 'null')
    } catch {
        return null
    }
}

const stayOnInformationStep = (store) => {
    if (store && typeof store.onTapCheckout === 'function') {
        store.onTapCheckout(ETapCheckout.information)
    }
}

const loadParentPaymentPrefill = async () => {
    const authStore = useAuthStore()
    const localUser = storedUser()
    const empty = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
    }

    if (!authStore.isLogined && !localUser?.jwt) {
        return empty
    }

    const jwt = authStore.user?.jwt || localUser?.jwt

    if (jwt) {
        setAuthorizationToken(jwt)
    }

    const login = firstText(authStore.user?.userLogin, localUser?.userLogin)

    try {
        const profile = authStore.getUserDetails || (await getCustomerProfile())

        return {
            first_name: firstText(profile?.firstName),
            last_name: firstText(profile?.lastName),
            email: firstText(profile?.email, login.includes('@') ? login : ''),
            phone: firstText(profile?.phone),
        }
    } catch {
        return {
            ...empty,
            email: login.includes('@') ? login : '',
        }
    }
}

const CART_FLOW_ROUTES = ['/cart', '/cart/checkout']

export const isCartFlowRoute = (name) => CART_FLOW_ROUTES.includes(name)

export const clearProgramCart = () => {
    const store = useCartProducts()

    if (typeof store.deleteAll === 'function') {
        store.deleteAll()
    }

    if (typeof store.setPromoCode === 'function') {
        store.setPromoCode('')
    }
}

export const startProgramCheckout = async ({workshop, sku, router}) => {
    const store = useCartProducts()
    const product = workshop?.sku ? workshop : await getPublicProductBySku(sku)
    const productSku = firstText(product?.sku, product?.productSku, sku)

    if (!product || !productSku) {
        throw new Error('Program not found')
    }

    const offers = await getPublicActualPrices(productSku)

    if (!Array.isArray(offers) || !offers.length) {
        throw new Error('This program is not available for purchase.')
    }

    const redirectUrl = firstText(product.redirectUrl)

    if (redirectUrl) {
        window.location.assign(redirectUrl)

        return
    }

    clearProgramCart()
    store.addToCart(product, offers, true, true)
    stayOnInformationStep(store)
    await router.push({name: '/cart'})
}

export {loadParentPaymentPrefill, stayOnInformationStep}
